import { render, staticRenderFns } from "./InvitationIndex.vue?vue&type=template&id=5871c917&scoped=true&"
import script from "./InvitationIndex.vue?vue&type=script&lang=js&"
export * from "./InvitationIndex.vue?vue&type=script&lang=js&"
import style0 from "./InvitationIndex.vue?vue&type=style&index=0&id=5871c917&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5871c917",
  null
  
)

export default component.exports